<template>
<b-row class="py-1">
  <b-col cols="11" offset="1">
    <div class="pb-2 text-danger" style="text-align: center; font-size: 24px; font-weight: 700">
      Legacy Siloed Database Tables
    </div>
    <div style="text-align: center" class="d-xs-block d-sm-none">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
    </div>
    <div style="text-align: center" class="d-none d-sm-block d-md-none d-lg-block d-xl-none">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
    </div>
    <div style="text-align: center" class="d-none d-md-block d-lg-none d-xl-block">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
      <img src="/images/db_icon.png" height="50" class="px-3">
    </div>
  </b-col>

</b-row>
</template>

<script>
export default {
  name: 'stack01'
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
